<div class="header">
  <div class="left">
    <!-- phones: slide-in menu -->
    <button type="button" class="menu-btn d-lg-none" aria-label="Open menu" (click)="toggleMobileMenu.emit()">
      <i class="bi bi-list"></i>
    </button>
   
    <div class="title">
      <h5 [title]="'Welcome, ' + greetingName">Welcome, {{ greetingName }}</h5>
      <!-- <span>T1DMitra App Management</span> -->
    </div>
  </div>
  <div class="new_class">
  
  <div class="actions">
    <div ngbDropdown placement="bottom-end" class="d-inline-block">
      <button type="button" ngbDropdownToggle class="user-toggle" aria-label="Account menu">
        <span class="user-avatar">
          @if (initials) {
            {{ initials }}
          } @else {
            <i class="bi bi-person-fill"></i>
          }
        </span>
        <span class="user-meta d-none d-md-flex">
          <span class="user-name">Profile</span>
        </span>
        <i class="bi bi-chevron-down user-chevron"></i>
      </button>

      <div ngbDropdownMenu class="user-menu">
        <div class="user-menu-head">
          <span class="user-avatar lg">
            @if (initials) {
              {{ initials }}
            } @else {
              <i class="bi bi-person-fill"></i>
            }
          </span>
          <div class="user-menu-info">
            <strong>{{ username }}</strong>
            @if (roleLabel) {
              <span class="role-badge">{{ roleLabel }}</span>
            }
          </div>
        </div>
        <!-- read-only; N/A when the login response does not include it -->
        <dl class="profile-details">
          <div>
            <dt>Name</dt>
            <dd>{{ username || 'N/A' }}</dd>
          </div>
          <div>
            <dt>Clinic Name</dt>
            <dd>{{ clinicName || 'N/A' }}</dd>
          </div>
          <div>
            <dt>Organisation</dt>
            <dd>{{ orgName || 'N/A' }}</dd>
          </div>
          <div>
            <dt>Email ID</dt>
            <dd>{{ email || 'N/A' }}</dd>
          </div>
        </dl>
        <div class="user-menu-body">
          <button type="button" ngbDropdownItem class="user-menu-item" (click)="changePassword.emit()">
            <span class="item-icon"><i class="bi bi-key"></i></span> Change Password
          </button>
          <button type="button" ngbDropdownItem class="user-menu-item logout" [disabled]="isLoggingOut" (click)="logout()">
            <span class="item-icon">
              @if (isLoggingOut) {
                <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
              } @else {
                <i class="bi bi-box-arrow-right"></i>
              }
            </span>
            {{ isLoggingOut ? 'Logging out...' : 'Logout' }}
          </button>
        </div>
      </div>
    </div>
 
  </div>
       <!-- <img src="./mitra.png" alt="Logo" class="form-logo"> -->

    <!-- <img src="./T1DMitra.jpg" alt="T1DMitra Logo" class="form-logo ms-auto"  > -->
     </div>

</div>
